import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
import Button from "../Components/CustomButtons/Button";
const Contact = () => {
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [subject, setSubject] = useState("");
	const GOOGLE_FORM_NAME_ID = "entry.2005620554";
	const GOOGLE_FORM_EMAIL_ID = "entry.1045781291";
	const GOOGLE_FORM_SUBJECT_ID = "entry.1106025482";
	const GOOGLE_FORM_MESSAGE_ID = "entry.839337160";
	return (
		<div className="container" style={{ color: "white" }}>
			<h3 style={{ textAlign: "center", fontSize: 80 }}>Contact</h3>
			<h6 style={{ textAlign: "center", fontSize: 20 }}>
				{" "}
				<Link to="/">Home</Link> <span style={{ marginLeft: 20 }}> / </span>{" "}
				<span style={{ marginLeft: 20 }}> Contact </span>
			</h6>
			<p
				style={{
					margin: "25px auto",
					fontSize: 16,
					textAlign: "justify",
					width: "60%",
				}}
			>
				Contact me if you liked my projects and content and ready to work with
				me on new enovative projects. We are always ready to listen concern and
				feedback.If you want collborate send me a note, and let’s get started on
				project today!
			</p>
			<div className="row" style={{ width: "60%" }}>
				<form
					action="https://docs.google.com/forms/d/e/1FAIpQLScytJjc5adPCC2xG80Qd0sBsN18yDw33kgRcJMdGLtAs8DYsQ/formResponse"
					class="col s12"
				>
					<div class="row">
						<div class="input-field col s12">
							<input
								name={GOOGLE_FORM_NAME_ID}
								type="text"
								class="validate"
								value={name}
								onChange={(event) => {
									setName(event.target.value);
								}}
								required="required"
								data-error="Name is required."
							/>
							<label for="icon_prefix">First Name</label>
						</div>
						<div class="input-field col s12">
							<input
								name={GOOGLE_FORM_EMAIL_ID}
								type="email"
								class="validate"
								value={email}
								onChange={(event) => {
									setEmail(event.target.value);
								}}
								required="required"
								data-error="Email is required."
							/>
							<label for="icon_telephone">Email</label>
						</div>
						<div class="input-field col s12">
							<input
								name={GOOGLE_FORM_SUBJECT_ID}
								type="text"
								class="validate"
								value={subject}
								onChange={(event) => {
									setSubject(event.target.value);
								}}
								required="required"
								data-error="Subject is required."
							/>
							<label for="icon_telephone">Subject</label>
						</div>
						<div class="input-field col s12">
							<textarea
								style={{
									borderTop: "none",
									borderLeft: "none",
									borderRight: "none",
									height: 100,
								}}
								name={GOOGLE_FORM_MESSAGE_ID}
								type="text"
								class="validate"
								value={message}
								onChange={(event) => {
									setMessage(event.target.value);
								}}
								required="required"
								data-error="Subject is required."
							></textarea>
							<label for="icon_telephone">Message</label>
						</div>

						<center>
							<Button
								style={{
									backgroundColor: "#31313a",
									width: "auto",
									textAlign: "center",
								}}
								type="submit"
							>
								Send Message
							</Button>
						</center>
					</div>
				</form>
			</div>
			<Footer />
		</div>
	);
};
export default Contact;
